import { render, staticRenderFns } from "./WorkRelationForm.vue?vue&type=template&id=b5ac5802&scoped=true&"
import script from "./WorkRelationForm.vue?vue&type=script&lang=ts&"
export * from "./WorkRelationForm.vue?vue&type=script&lang=ts&"
import style0 from "./WorkRelationForm.vue?vue&type=style&index=0&id=b5ac5802&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5ac5802",
  null
  
)

export default component.exports